import { HEROS_SERVICE } from "@/services/heros.service.js";

const state = {postHeroOutput: false, getHerosOutput: {}, putHeroOutput: false, getHeroByIdOutput: {}, deleteHeroByIdOutput: false, putHeroStatusByIdOutput: false};

const actions = {
    //Service to create hero content
    postHero({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postHeroRequest');

        HEROS_SERVICE.postHero(input)
            .then(
                output => {
                    commit('postHeroSuccess', output);
                },
                error => {
                    commit('postHeroFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated hero content
    getHeros({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getHerosRequest');

        HEROS_SERVICE.getHeros(queryParams)
            .then(
                output => {
                    commit('getHerosSuccess', output);
                },
                error => {
                    commit('getHerosFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update hero content
    putHero({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putHeroRequest');

        HEROS_SERVICE.putHero(input)
            .then(
                output => {
                    commit('putHeroSuccess', output);
                },
                error => {
                    commit('putHeroFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get hero details
    getHeroById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getHeroByIdRequest');


        HEROS_SERVICE.getHeroById(id)
            .then(
                output => {
                    commit('getHeroByIdSuccess', output);
                },
                error => {
                    console.log(error)
                    commit('getHeroByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete heros
    deleteHeroById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteHeroByIdRequest');

        HEROS_SERVICE.deleteHeroById(id)
            .then(
                output => {
                    commit('deleteHeroByIdSuccess', output);
                },
                error => {
                    commit('deleteHeroByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to change hero status
    putHeroStatusById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('putHeroStatusByIdRequest');

        HEROS_SERVICE.putHeroStatusById(id)
            .then(
                output => {
                    commit('putHeroStatusByIdSuccess', output);
                },
                error => {
                    commit('putHeroStatusByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postHero
    postHeroRequest(state) {
        state.postHeroOutput = null;
    },
    postHeroSuccess(state, output) {
        state.postHeroOutput = true;
    },
    postHeroFailure(state) {
        state.postHeroOutput = false;
    },

    //getHeros
    getHerosRequest(state) {
    },
    getHerosSuccess(state, output) {
        state.getHerosOutput = output;
    },
    getHerosFailure(state) {
        state.getHerosOutput = false;
    },

    //putHero
    putHeroRequest(state) {
        state.putHeroOutput = null;
    },
    putHeroSuccess(state, output) {
        state.putHeroOutput = true;
    },
    putHeroFailure(state) {
        state.putHeroOutput = false;
    },

    //getHeroById
    getHeroByIdRequest(state) {
    },
    getHeroByIdSuccess(state, output) {
        state.getHeroByIdOutput = output;
    },
    getHeroByIdFailure(state) {
        state.getHeroByIdOutput = false;
    },

    //deleteHeroById
    deleteHeroByIdRequest(state) {
        state.deleteHeroByIdOutput = null;
    },
    deleteHeroByIdSuccess(state, output) {
        state.deleteHeroByIdOutput = true;
    },
    deleteHeroByIdFailure(state) {
        state.deleteHeroByIdOutput = false;
    },

    //putHeroStatusById
    putHeroStatusByIdRequest(state) {
        state.putHeroStatusByIdOutput = null;
    },
    putHeroStatusByIdSuccess(state, output) {
        state.putHeroStatusByIdOutput = true;
    },
    putHeroStatusByIdFailure(state) {
        state.putHeroStatusByIdOutput = false;
    },
};

export const heros = {
    namespaced: true,
    state,
    actions,
    mutations
};